import { MultiDropdown } from '@instinet-analytics/semantic-ui-components';
import { useIndexEventsTradeCategories } from '../../use-index-events-trade-categories';

import './IndexEventsTradeCategoryDropdown.css';

const IndexEventsTradeCategoryDropdown = ({
    tradeCategories,
    onChangeTradeCategories,
}: {
    tradeCategories: string[];
    onChangeTradeCategories: (nextTradeCategories: string[]) => void;
}) => {
    const options = useIndexEventsTradeCategories();

    return (
        <MultiDropdown
            className="IndexEventsTradeCategoryDropdown"
            options={options}
            selectedValues={tradeCategories}
            onChange={onChangeTradeCategories}
            placeholder={'All Trade Categories'}
            inlineToolbar={true}
        />
    );
};

export default IndexEventsTradeCategoryDropdown;
